<template>
    <b-container fluid class="animated fadeIn" v-if="!companies.loading">
        <div style="width: 90%; margin: 0 auto; margin-top: 10px; ">
            <a-input
                v-model="filter"
                size="large"
                style="margin-bottom: 10px;"
            />
            <a-row :gutter="10" type="flex">
                <a-col
                    :lg="{ span: 6 }"
                    :md="{ span: 24 }"
                    v-for="company in filteredCompanies"
                    :key="company.id"
                >
                    <a-card
                        hoverable
                        :title="company.name"
                        :bordered="true"
                        style="margin-bottom: 10px"
                        class="animated fadeOut"
                    >
                        <template class="ant-card-actions" slot="actions">
                            <!-- Units/Directory -->
                            <router-link
                                v-if="authIsAdmin"
                                :to="
                                    './organization/' +
                                        company.id +
                                        '/directory'
                                "
                            >
                                <a-button type="default">
                                    <i class="icon-organization" />
                                    <span
                                        >&nbsp;
                                        {{ $t('label.directory') }}</span
                                    >
                                </a-button>
                            </router-link>

                            <!-- Groups -->
                            <router-link
                                :to="'./organization/' + company.id + '/groups'"
                            >
                                <a-button type="default">
                                    <i class="icon-organization" />
                                    <span>&nbsp; {{ $t('label.groups') }}</span>
                                </a-button>
                            </router-link>

                            <!-- Userlist link -->
                            <router-link :to="'./organization/' + company.id">
                                <a-button type="default">
                                    <i class="icon-organization" />
                                    <span
                                        >&nbsp; {{ $t('label.userList') }}</span
                                    >
                                </a-button>
                            </router-link>
                        </template>
                    </a-card>
                </a-col>
            </a-row>
        </div>
    </b-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    components: {},

    created() {
        //this.$router.push('./organization/' + this.user.company.id)
        // this.companies.fetch()
        this.$store.dispatch('companies/getCompanies')
    },

    data() {
        return {
            filter: '',
        }
    },

    computed: {
        ...mapGetters({
            user: 'auth/user',
            authIsAdmin: 'auth/isGlobalAdmin',
            loading: 'companies/isLoading',
            companies: 'companies/companies',
            company: 'companies/company',
        }),

        filteredCompanies() {
            return this.companies.filter(c => {
                return (
                    c.name.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
                )
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.thumbnail {
    i {
        font-size: 5.5rem;
        text-align: center;
        display: block;
    }
    span {
        font-size: 2rem;
        font-weight: bold;
    }
    // p {
    // }
}
</style>
